// extracted by mini-css-extract-plugin
export default {"card":"LearningPathCardBase_card__ui+LK"};